import tw from 'tailwind-styled-components'

export const TwColorsContainer = tw.div`
  z-1
  flex
  gap-8
  p-8
  shadow-task-old
  rounded-4
  w-min
  absolute
  top-30
  bg-main-old
`

export const TwIcon = tw.div`
  flex
  grow-0
  w-20
  h-20
  rounded-full
  cursor-pointer
`

export const TwSaveButton = tw.div`
  cursor-pointer
  text-action-default
  active:text-action-pressed
  hover:text-action-default
  ml-16
  text-12
`
